import { Typography, styled } from '@lingoda/ui';

export const StyledPostCheckoutPagesSubTitle = styled(Typography)(({ theme }) => ({
    color: theme.palette.text.primary,
    opacity: 0.7,
}));
